var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTips),expression:"isShowTips"}],staticClass:"tips-box"},[_c('div',{staticClass:"van-overlay",staticStyle:{"z-index":"5000"},on:{"click":_vm.cancel}}),_c('div',{staticClass:"tips-content",domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.cancel}})])
}
var staticRenderFns = []

export { render, staticRenderFns }